import { getQuoteProperty, isImmutableQuote } from 'quotes-ui-lib/utils/quote';
/**
 * Extracts the templateType from a quote object for tracking purposes
 */
export const getQuoteTemplateType = quote => {
  const normalizedQuote = isImmutableQuote(quote) ? quote.toJS() : quote;
  return getQuoteProperty(normalizedQuote, 'hs_template_type');
};